import { useGetRequest } from 'hooks/utils/useGetRequest';

// TODO: type return
const useGetCardProduct = (cardProductId: string): any => {
  const path = `v1/card_products/${cardProductId}`;

  const [{ data, error, loading }] = useGetRequest({ path });

  return {
    cardProduct: data,
    isLoading: loading,
    isError: error,
  };
};

export default useGetCardProduct;
